export default __webpack_public_path__ + "static/media/1.0492d8f0.svg";